import { render, staticRenderFns } from "./data-sources.vue?vue&type=template&id=32637eb0&scoped=true"
import script from "./data-sources.vue?vue&type=script&lang=js"
export * from "./data-sources.vue?vue&type=script&lang=js"
import style0 from "./data-sources.vue?vue&type=style&index=0&id=32637eb0&prod&lang=less&scoped=true"
import style1 from "./data-sources.vue?vue&type=style&index=1&id=32637eb0&prod&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "32637eb0",
  null
  
)

export default component.exports